import React from "react"
// import Layout from "../components/Layout"
// import SEO from "../components/Seo"
// import Hero from "../components/Home/Hero"
// import Pilosophy from "../components/Home/Pilosophy"
// import WhyWork from "../components/Home/WhyWork"
// import WorkTravel from "../components/Home/WorkTravel"
// import Testimonios from "../components/Home/Testimonios"

const IndexPage = () => (
  // <Layout>
  //   <SEO title="Hire developers in days instead of months" description="In Avalith are passionate about the development of digital products. We have been empowering big companies from our home for more than 10 years." />
  //   <Hero />
  //   <Pilosophy />
  //   <WhyWork />
  //   <WorkTravel />
  //   <Testimonios />
  // </Layout>
  <div>forbidden route</div>
)

export default IndexPage
